import { Conta, getAgenciaContaComissionado } from "#/api/getAgenciaConta";
import { toast } from "@sicredi/react";
import {
  IDownloadFilePDF,
  IGetBensGrupoByIdSimulacao,
  IGetListaPaginacao,
  IGetTotalPaginas,
  IGetVendasListaPropostaByIdDocumento,
  IHandleDetalhesContrato,
  IHandleEmitirBoleto,
  IHandleEmitirRegulamento,
  INavigateSetIdRoute,
  IVerifyUserHasOnlyOneAccount,
  TYPE_OS,
} from "./ContextProverModel";
import { Base64 } from "js-base64";
import { getVendasEmitirRegulamento } from "#/api/getVendasEmitirRegulamento";
import { getVendasBoleto } from "#/api/getVendasBoleto";
import dayjs from "dayjs";
import { DataListaProposta } from "#/api/getVendasListaProposta";
import { BensGruposReturn } from "#/api/getBens";
import { getVendasContrato } from "#/api/getVendasContrato";

export const verificarUserQuantidadesConta = async ({
  documento,
}: IVerifyUserHasOnlyOneAccount): Promise<Conta | undefined> => {
  try {
    const { data } = await getAgenciaContaComissionado({ documento });

    if (data.contas.length === 1) {
      return data.contas[0];
    } else {
      return undefined;
    }
  } catch {
    toast.error("Cadastrado não encontrado");
  }
};

export const formatValueMoney = (valor: number | undefined) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(valor ?? 0);
};

export const formatRegexCep = (cep: string): string => {
  const regexCEP = /^(\d{5})(\d{3})$/;
  if (regexCEP.test(cep)) {
    return cep.replace(regexCEP, "$1-$2");
  } else {
    return "Cep inválido.";
  }
};

export const formatRegexCpfCnpj = (documento: string): string => {
  const regexCPF = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;
  const regexCNPJ = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;
  if (regexCPF.test(documento)) {
    return documento.replace(regexCPF, "$1.$2.$3-$4");
  } else if (regexCNPJ.test(documento)) {
    return documento.replace(regexCNPJ, "$1.$2.$3/$4-$5");
  } else {
    return documento;
  }
};

export const formatValueMoneyInput = (valor: string) => {
  const num = Number(valor.replace(/\D/g, "")) / 100;
  return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const navigateSetIdRoute = ({
  id,
  idComercial,
  setIdProduto,
  navigate,
  PAGE,
}: INavigateSetIdRoute) => {
  if (!id) {
    setIdProduto(Number(id));
  }
  const idComercialParam =
    idComercial !== undefined && idComercial !== null
      ? "&idComercial=" + idComercial
      : "";
  navigate(PAGE + "?id=" + id + idComercialParam);
};

export const getIdURL = (search: string) => {
  return new URLSearchParams(search).get("id") as string;
};

export const getIdComercialURL = (search: string) => {
  return new URLSearchParams(search).get("idComercial") as string;
};

export const toastErrorMenssage = (message?: string) => {
  if (message) {
    toast.error(message);
  } else {
    toast.error(
      "Não foi possível finalizar a tarefa, por favor, tente novamente mais tarde."
    );
  }
};

export const getDigito = (conta: string) => {
  return conta[conta.length - 1];
};

export const downloadFilePDF = ({
  base64DataFile,
  nameFile,
}: IDownloadFilePDF) => {
  try {
    const byteArray = Base64.toUint8Array(base64DataFile);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${nameFile}.pdf`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    toast.success(`Download do arquivo ${nameFile} feito com sucesso!`);
  } catch {
    toastErrorMenssage();
  }
};

export const handleEmitirRegulamento = async ({
  idProduto,
  codigoComissionado,
  setIsLoading,
}: IHandleEmitirRegulamento) => {
  try {
    setIsLoading(true);
    const regulamento = await getVendasEmitirRegulamento({
      idProduto,
      codigoComissionado,
    });
    const base64DataFile = regulamento.data.regulation;
    downloadFilePDF({ base64DataFile, nameFile: "regulamento_Sicredi" });
    setIsLoading(false);
  } catch {
    setIsLoading(false);
    toastErrorMenssage();
  }
};

export const handleImitirBoleto = async ({
  idDocumento,
  codigoComissionado,
  setIsLoading,
  documento,
}: IHandleEmitirBoleto) => {
  try {
    setIsLoading(true);
    const vendaBoleto = await getVendasBoleto({
      idDocumento,
      codigoComissionado,
      documento,
    });
    downloadFilePDF({
      base64DataFile: vendaBoleto?.data.bill,
      nameFile: "boleto_Sicredi",
    });
    setIsLoading(false);
    return vendaBoleto;
  } catch {
    setIsLoading(false);
    toastErrorMenssage();
  }
};

export const getVendasListaPropostaByIdDocumento = ({
  vendasListaProposta,
  idDocumento,
}: IGetVendasListaPropostaByIdDocumento) => {
  if (typeof vendasListaProposta.data !== "undefined") {
    return vendasListaProposta?.data.find(
      (item) => item?.idDocumento === idDocumento
    );
  }
};

export const getBensGruposByIdSimulacao = ({
  bensGrupos,
  idSimulacao,
}: IGetBensGrupoByIdSimulacao) => {
  return bensGrupos.find((item) => item.idSimulacao === idSimulacao);
};

export const getUserOS = (): TYPE_OS => {
  const userAgent = window.navigator.userAgent;
  if (/Windows NT/i.test(userAgent)) {
    return TYPE_OS.Windows;
  }
  if (/Mac/i.test(userAgent)) {
    return TYPE_OS.MacOS;
  }
  if (/Linux/i.test(userAgent)) {
    return TYPE_OS.Linux;
  }
  if (/Android/i.test(userAgent)) {
    return TYPE_OS.Android;
  }
  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return TYPE_OS.iOS;
  }
  return TYPE_OS.Unknown;
};

export const handleGoAppStore = () => {
  const userAgent = navigator.userAgent;
  const iOS = !!userAgent.match(/iPhone|iPad|iPod/);
  const isAndroid = /android/i.test(userAgent);
  let url = "";

  if (isAndroid) {
    url =
      "https://play.google.com/store/apps/details?id=com.autoatendimento.sicredi";
  } else if (iOS) {
    url = "https://apps.apple.com/us/app/consórcio-do-sicredi/id1629062282";
  } else {
    url = "https://canaldoconsorciado.sicredi.com.br/";
  }
  window.location.href = url;
};

export const handleGoAppStorePropostaAceita = () => {
  const userAgent = navigator.userAgent;
  const iOS = !!userAgent.match(/iPhone|iPad|iPod/);
  const isAndroid = /android/i.test(userAgent);
  let url = "";

  if (isAndroid) {
    url =
      "https://play.google.com/store/apps/details?id=br.com.sicredimobi.smart";
  } else if (iOS) {
    url = "https://apps.apple.com/br/app/sicredi-para-smartphone/id1041468908";
  } else {
    url = "https://www.sicredi.com.br/";
  }
  window.location.href = url;
};

export const formatDate = (dataBoleto: string) => {
  return dayjs(dataBoleto).format("DD/MM/YYYY");
};

export const getTotalPaginas = ({
  quantidadeLista,
  quantidadePorPagina,
}: IGetTotalPaginas) => {
  if (quantidadeLista) {
    const paginas = quantidadeLista / quantidadePorPagina;
    return Math.ceil(paginas);
  } else {
    return 0;
  }
};

export const getListaPaginacaoListaProposta = ({
  apiLista,
  atualPagina,
  quantidadePorPagina,
}: IGetListaPaginacao<DataListaProposta>) => {
  if (apiLista) {
    return apiLista.slice(0, atualPagina * quantidadePorPagina);
  } else {
    return [];
  }
};
export const getListaPaginacaoEscolhaPlano = ({
  apiLista,
  atualPagina,
  quantidadePorPagina,
}: IGetListaPaginacao<BensGruposReturn>) => {
  if (apiLista) {
    return apiLista.slice(0, atualPagina * quantidadePorPagina);
  } else {
    return [];
  }
};

export const handleDetalhesContrato = async ({
  conta,
  codigoComissionado,
  idDocumento,
  cooperativa,
  documento,
  setIsLoading,
  setVendasContrato,
}: IHandleDetalhesContrato) => {
  try {
    setIsLoading(true);
    const vendasContrato = await getVendasContrato({
      codigoComissionado,
      idDocumento,
      conta,
      cooperativa,
      documento,
    });
    setVendasContrato(vendasContrato);
    setIsLoading(false);
    return vendasContrato;
  } catch {
    setIsLoading(false);
    toastErrorMenssage();
  }
};

export const saveSessionStorage = (key: string, value: any) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};
export const loadSessionStorage = (key: string) => {
  const storedValue = sessionStorage.getItem(key);
  if (storedValue) {
    return JSON.parse(storedValue);
  } else {
    return null;
  }
};

export const getValorDecodeBase64 = (base64: string) => {
  if (base64) {
    return Base64.decode(base64);
  } else {
    return "undefined";
  }
};

export const getPercentualTaxaAdm = (
  percentualTaxaAdm: number,
  prazoRestante: number
) =>
  Number.parseFloat(String(Number(percentualTaxaAdm / prazoRestante))).toFixed(
    2
  ) as unknown as number;
